import React, { useEffect, useState } from 'react'
import Box from '@mui/material/Box'
import Modal from '@mui/material/Modal'
import { useModalContext } from '../../../contexts/ModalContext'
import TextField from '@mui/material/TextField'
import { Container, FormContainer, Column } from './styles'
import 'react-data-table-component-extensions/dist/index.css'
import * as MechanicsService from '../../../services/mechanics'
import * as StatesService from '../../../services/statesAndCities'
import Button from '@mui/material/Button'
import Autocomplete from '@mui/material/Autocomplete'
import MenuItem from '@mui/material/MenuItem'
import { styled } from '@mui/material/styles'
import CloudUploadIcon from '@mui/icons-material/CloudUpload'

const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1
})

const NewMechanicModal = ({ updateTable }) => {
    const [states, setStates] = useState([])
    const [cities, setCities] = useState([])

    const { setModal } = useModalContext('')
    const [name, setName] = useState('')
    const [address, setAddress] = useState('')
    const [number, setNumber] = useState('')
    const [complement, setComplement] = useState('')
    const [neighborhood, setNeighborhood] = useState('')
    const [cep, setCep] = useState('')
    const [bandeira, setBandeira] = useState('')
    const [placeId, setPlaceId] = useState('')
    const [latitude, setLatitude] = useState('')
    const [longitude, setLongitude] = useState('')
    const [establishmentType, setEstablishmentType] = useState('')
    const [state, setState] = useState('')
    const [city, setCity] = useState('')
    const [phone, setPhone] = useState('')
    const [logoFile, setLogoFile] = useState(null)
    const [logoPreview, setLogoPreview] = useState(null)
    const [isUploading, setIsUploading] = useState(false)

    useEffect(() => {
        async function getStates() {
            const response = await StatesService.getStates()
            setStates(response)
        }

        getStates()
    }, [])

    useEffect(() => {
        async function getCities() {
            const response = await StatesService.getCities(state)
            setCities(response)
        }

        getCities()
    }, [state])

    const handleClose = () => setModal(null)

    const handleFileChange = (event) => {
        const file = event.target.files[0]
        if (file) {
            setLogoFile(file)
            // Create preview URL
            const previewUrl = URL.createObjectURL(file)
            setLogoPreview(previewUrl)
        }
    }

    const removeLogo = () => {
        setLogoFile(null)
        if (logoPreview) {
            URL.revokeObjectURL(logoPreview)
            setLogoPreview(null)
        }
    }

    const addMechanic = async (event) => {
        event.preventDefault()
        setIsUploading(true)

        try {
            const body = {
                name,
                address,
                number,
                complement,
                neighborhood,
                cep,
                bandeira,
                placeId,
                latitude: parseFloat(latitude),
                longitude: parseFloat(longitude),
                establishmentType,
                state,
                city,
                phone
            }

            console.log(body)

            // First save the mechanic
            const mechanicResponse = await MechanicsService.saveMechanic(body)

            // If there's a logo file and mechanic was saved successfully, upload the logo
            if (logoFile && mechanicResponse && mechanicResponse.id) {
                try {
                    await MechanicsService.saveMechanicLogo(mechanicResponse.id, logoFile)
                    console.log('Logo uploaded successfully')
                } catch (logoError) {
                    console.error('Error uploading logo:', logoError)
                    // Don't fail the entire operation if logo upload fails
                    alert('Mecânica adicionada, mas houve erro ao fazer upload do logo')
                }
            }

            alert('Mecânica adicionada com sucesso!')
            setModal(null)
            updateTable()
        } catch (error) {
            console.error('Error adding mechanic:', error)
            alert('Erro ao adicionar esta mecânica!')
        } finally {
            setIsUploading(false)
        }
    }

    return (
        <>
            <Modal
                open={true}
                onClose={handleClose}
                aria-labelledby='modal-modal-title'
                aria-describedby='modal-modal-description'
            >
                <Container>
                    <Box
                        m={3}
                        fontWeight='bold'
                        color='#666666'
                        fontSize={{
                            xs: 'h7.fontSize',
                            sm: 'h7.fontSize',
                            md: 'h6.fontSize',
                            xl: 'h5.fontSize'
                        }}
                    >
                        Novo Estabelecimento
                    </Box>

                    <form onSubmit={addMechanic}>
                        {/* Logo Upload Section */}
                        <Box mb={3} p={2} border={1} borderColor='#e0e0e0' borderRadius={1}>
                            <Box mb={2} fontWeight='bold' color='#666666'>
                                Logo do Estabelecimento
                            </Box>

                            <Box display='flex' alignItems='center' gap={2}>
                                <Button
                                    component='label'
                                    variant='outlined'
                                    startIcon={<CloudUploadIcon />}
                                    disabled={isUploading}
                                >
                                    Selecionar Logo
                                    <VisuallyHiddenInput type='file' accept='image/*' onChange={handleFileChange} />
                                </Button>

                                {logoFile && (
                                    <Button
                                        variant='outlined'
                                        color='error'
                                        onClick={removeLogo}
                                        disabled={isUploading}
                                    >
                                        Remover
                                    </Button>
                                )}
                            </Box>

                            {logoFile && (
                                <Box mt={2}>
                                    <Box mb={1} fontSize='14px' color='#666'>
                                        Arquivo selecionado: {logoFile.name}
                                    </Box>
                                    {logoPreview && (
                                        <Box
                                            component='img'
                                            src={logoPreview}
                                            alt='Preview do logo'
                                            sx={{
                                                maxWidth: 200,
                                                maxHeight: 200,
                                                objectFit: 'contain',
                                                border: '1px solid #e0e0e0',
                                                borderRadius: 1
                                            }}
                                        />
                                    )}
                                </Box>
                            )}
                        </Box>

                        <FormContainer>
                            <Column>
                                <TextField
                                    name='name'
                                    label='Nome'
                                    variant='outlined'
                                    style={{ width: '100%', marginBottom: '16px' }}
                                    onChange={(event) => setName(event.target.value)}
                                    required
                                />
                                <TextField
                                    name='address'
                                    label='Endereço'
                                    variant='outlined'
                                    style={{ width: '100%', marginBottom: '16px' }}
                                    onChange={(event) => setAddress(event.target.value)}
                                    required
                                />
                                <TextField
                                    required
                                    name='number'
                                    label='Número'
                                    variant='outlined'
                                    style={{ width: '100%', marginBottom: '16px' }}
                                    onChange={(event) => setNumber(event.target.value)}
                                />
                                <TextField
                                    name='complement'
                                    label='Complemento'
                                    variant='outlined'
                                    style={{ width: '100%', marginBottom: '16px' }}
                                    onChange={(event) => setComplement(event.target.value)}
                                />
                                <TextField
                                    name='neighborhood'
                                    label='Bairro'
                                    variant='outlined'
                                    style={{ width: '100%', marginBottom: '16px' }}
                                    onChange={(event) => setNeighborhood(event.target.value)}
                                />
                                <TextField
                                    name='cep'
                                    label='CEP'
                                    variant='outlined'
                                    style={{ width: '100%', marginBottom: '16px' }}
                                    onChange={(event) => setCep(event.target.value)}
                                />
                                <TextField
                                    name='bandeira'
                                    label='Bandeira (apenas para postos)'
                                    variant='outlined'
                                    style={{ width: '100%', marginBottom: '16px' }}
                                    onChange={(event) => setBandeira(event.target.value)}
                                />
                            </Column>
                            <Column>
                                <TextField
                                    name='placeId'
                                    label='Place ID'
                                    variant='outlined'
                                    style={{ width: '100%', marginBottom: '16px' }}
                                    onChange={(event) => setPlaceId(event.target.value)}
                                    required
                                />
                                <TextField
                                    name='latitude'
                                    label='Latitude'
                                    type='number'
                                    variant='outlined'
                                    style={{ width: '100%', marginBottom: '16px' }}
                                    onChange={(event) => setLatitude(event.target.value)}
                                    required
                                    inputProps={{
                                        step: 'any'
                                    }}
                                />
                                <TextField
                                    name='longitude'
                                    label='Longitude'
                                    type='number'
                                    variant='outlined'
                                    style={{ width: '100%', marginBottom: '16px' }}
                                    onChange={(event) => setLongitude(event.target.value)}
                                    required
                                    inputProps={{
                                        step: 'any'
                                    }}
                                />
                                <TextField
                                    select
                                    name='establishmentType'
                                    label='Tipo de Estabelecimento'
                                    variant='outlined'
                                    style={{ width: '100%', marginBottom: '16px' }}
                                    onChange={(event) => setEstablishmentType(event.target.value)}
                                    required
                                    value={establishmentType}
                                >
                                    <MenuItem value='MECHANIC'>Mecânica / Oficina</MenuItem>
                                    <MenuItem value='GAS_STATION'>Posto de Gasolina</MenuItem>
                                    <MenuItem value='CAR_WASH'>Lavagem de Carros</MenuItem>
                                    <MenuItem value='PARKING'>Estacionamento</MenuItem>
                                </TextField>
                                <Autocomplete
                                    disablePortal
                                    id='state'
                                    options={states}
                                    getOptionLabel={(option) => option.sigla + ' - ' + option.nome}
                                    isOptionEqualToValue={(option, value) => option.sigla === value.sigla}
                                    onChange={(_, value) => setState(value.sigla)}
                                    renderInput={(params) => <TextField {...params} required label='Estado' />}
                                    style={{ width: '100%', marginBottom: '16px' }}
                                />
                                <Autocomplete
                                    disablePortal
                                    id='city'
                                    options={cities}
                                    getOptionLabel={(option) => option.nome}
                                    isOptionEqualToValue={(option, value) => option.nome === value.nome}
                                    onSelect={(event) => setCity(event.target.value)}
                                    renderInput={(params) => <TextField {...params} required label='Cidade' />}
                                    style={{ width: '100%', marginBottom: '16px' }}
                                />
                                <TextField
                                    required
                                    name='phone'
                                    label='Telefone'
                                    variant='outlined'
                                    style={{ width: '100%', marginBottom: '16px' }}
                                    onChange={(event) => setPhone(event.target.value)}
                                />
                            </Column>
                        </FormContainer>
                        <Box display='flex' justifyContent='flex-end' padding='20px' justifySelf='center'>
                            <Button
                                variant='contained'
                                type='submit'
                                style={{ marginRight: '4px' }}
                                disabled={isUploading}
                            >
                                {isUploading ? 'Adicionando...' : 'Adicionar'}
                            </Button>
                            <Button variant='outlined' onClick={() => handleClose()} disabled={isUploading}>
                                Fechar
                            </Button>
                        </Box>
                    </form>
                </Container>
            </Modal>
        </>
    )
}

export default NewMechanicModal
